// @flow
import { RESORT_PRICE_TICKET } from 'Client/cms/toolkit/constants';
import { ProductPriceTicketLine } from 'Components/lines/product-price-ticket-line/ProductPriceTicketLine';
import { productPriceTicketResolver } from './productPriceTicket.resolver';

export const productPriceTicketDescriptor = {
  name: RESORT_PRICE_TICKET,
  component: ProductPriceTicketLine,
  resolve: productPriceTicketResolver.resolve,
};
